import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/create/')({
  beforeLoad: () => {
    // Redirect to the first step
    throw redirect({
      to: '/workspace/create/name',
    });
  },
});
